import type { PosVariant, PosVariantDetailItem } from '../types';

export function mapDetailToPosVariant(detail: PosVariantDetailItem): PosVariant {
  const weightStr = detail.variant.attrs.weight_g?.value;
  const weight = weightStr !== undefined ? Number(weightStr) : NaN;
  return {
    product_id: detail.product.product_id,
    // Chuyển THẲNG, không dựng lại: mọi quyết định (có chương trình hay không,
    // còn bao nhiêu suất) đã do BE chốt ở `getVariantDetails`.
    flash_sale: detail.flash_sale,
    brand_id: detail.product.brand_id ?? undefined,
    // Fix round 2 (F5): `detail.product.category_id` là MẢNG (BE trả nguyên
    // `product.category_id: ObjectId[]`, xem comment ở `PosVariant.category_ids`).
    // Chuẩn hoá mảng rỗng/thiếu thành `undefined` — KHÔNG để `[]` đi tiếp,
    // tránh `buildEvaluateItems` phải tự đoán "mảng rỗng" có nghĩa gì.
    category_ids:
      detail.product.category_id && detail.product.category_id.length > 0
        ? detail.product.category_id
        : undefined,
    variant_id: detail.variant.variant_id,
    variant_name: detail.product.name,
    variant_display_name: detail.variant.variant_name ?? undefined,
    variant_code: detail.variant.variant_code,
    specification_code: detail.stock_serial?.serial ?? undefined,
    tracking_mode: detail.product.tracking_mode,
    unit_price: detail.variant.unit_price ?? undefined,
    price: Math.ceil(detail.price.price),
    weight: Number.isFinite(weight) && weight > 0 ? weight : undefined,

    vat: detail.product.vat,
    // Lookup trả `medias`, không có `image` phẳng sẵn (xem doc comment trên
    // `PosVariantDetailItem.product`) — suy ảnh đại diện bằng ĐÚNG quy tắc BE
    // đã dùng cho `GET /pos/variants` tìm kiếm (`pos-variant.service.ts`:
    // `product.medias?.[0]?.thumbnail || product.medias?.[0]?.url || ''`),
    // để hai đường (tìm kiếm vs. lookup dựng dòng giỏ) hiện CÙNG một ảnh cho
    // cùng sản phẩm.
    image: detail.product.medias?.[0]?.thumbnail || detail.product.medias?.[0]?.url || undefined,
    warehouse_staff_ids: detail.warehouse_staff_ids?.map((s) => s.warehouse_staff_id),
    // TCR-1517 — thành phần combo THẬT, chuyển THẲNG như `flash_sale`: mọi
    // quyết định ("có phải combo không", "bên trong có gì") đã do BE chốt ở
    // `getVariantDetails`. Thiếu ⇒ `undefined`, KHÔNG dựng `[]` (sản phẩm
    // thường không được mang field này, xem `PosVariantSearchItem`).
    is_combo_product: detail.is_combo_product,
    bom_components: detail.bom_components,
  };
}
